import { Trans } from '@lingui/macro';
import {
    convertDirectCallingMode,
    convertSecurityMode,
    jitterSquareColor,
    latencySquareColor,
    lossSquareColor,
} from './VoipPulseTestHelpers';

export default function VoipTestNowResultsChartsAndMetrics({ results, mosColor, classes }) {
    return (
        <table>
            <thead>
                <tr>
                    <th className={classes.callerMetrics}>
                        {results.test.testConfig.caller.name}
                        <br />
                        {results.config.results.caller.summary?.srcIpUsed}
                    </th>
                    <th className={classes.metricLabel} />
                    {results.isVoipPulse && (
                        <th className={classes.calleeMetrics}>
                            {results.test.testConfig.callee.name}
                            <br />
                            {results.config.results.callee.summary?.srcIpUsed}
                        </th>
                    )}
                    {!results.isVoipPulse && <th className={classes.calleeMetrics}>{results.test.testConfig.phone}</th>}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className={classes.callerMetrics}>{results.test.testConfig.caller.callManagerName || '--'}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Call Manager</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{results.test.testConfig.callee.callManagerName || '--'}</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{convertDirectCallingMode(results, false)}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Direct Calling</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{convertDirectCallingMode(results, true)}</td>
                </tr>
                {(results.test.testConfig.caller.voipConfiguration.phoneNumber ||
                    results.test.testConfig.callee.voipConfiguration?.phoneNumber) && (
                    <tr>
                        <td className={classes.callerMetrics}>
                            {results.test.testConfig.caller.voipConfiguration.phoneNumber || '--'}
                        </td>
                        <td className={classes.metricLabel}>
                            <Trans>Phone Number</Trans>
                        </td>
                        <td className={classes.calleeMetrics}>
                            {results.test.testConfig.callee.voipConfiguration?.phoneNumber || '--'}
                        </td>
                    </tr>
                )}

                {(results.test.testConfig.caller.voipConfiguration.extension ||
                    results.test.testConfig.callee.voipConfiguration?.extension) && (
                    <tr>
                        <td className={classes.callerMetrics}>
                            {results.test.testConfig.caller.voipConfiguration.extension || '--'}
                        </td>
                        <td className={classes.metricLabel}>
                            <Trans>Extension</Trans>
                        </td>
                        <td className={classes.calleeMetrics}>
                            {results.test.testConfig.callee.voipConfiguration?.extension || '--'}
                        </td>
                    </tr>
                )}

                <tr>
                    <td className={classes.callerMetrics}>{convertSecurityMode(results, false)}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Secure</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{convertSecurityMode(results, true)}</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>
                        {results.config.results.caller.avgsFmt.mos}
                        <i className={mosColor(results.config.results.caller.avgs.mos)} />
                    </td>
                    <td className={classes.metricLabel}>
                        <Trans>LQ MOS</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>
                        <i className={mosColor(results.config.results.callee.avgs?.mos)} />
                        {results.config.results.callee.avgsFmt.mos}
                    </td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>
                        {results.config.results.caller.avgsFmt.loss}
                        <i className={lossSquareColor(results.config.results.caller.avgs.loss)} />
                    </td>
                    <td className={classes.metricLabel}>
                        <Trans>Loss (%)</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>
                        <i className={lossSquareColor(results.config.results.callee.avgs?.loss)} />
                        {results.config.results.callee.avgsFmt.loss}
                    </td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>
                        {results.config.results.caller.avgsFmt.latency}
                        <i className={latencySquareColor(results.config.results.caller.avgs.latency)} />
                    </td>
                    <td className={classes.metricLabel}>
                        <Trans>Latency</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>
                        <i className={latencySquareColor(results.config.results.callee.avgs?.latency)} />
                        {results.config.results.callee.avgsFmt.latency}
                    </td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>
                        {results.config.results.caller.avgsFmt.jitter}
                        <i className={jitterSquareColor(results.config.results.caller.avgs.jitter)} />
                    </td>
                    <td className={classes.metricLabel}>
                        <Trans>Jitter</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>
                        <i className={jitterSquareColor(results.config.results.callee.avgs?.jitter)} />
                        {results.config.results.callee.avgsFmt.jitter}
                    </td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{results.test.testConfig.jitter + results.MS}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Jitter Buffer</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{results.test.testConfig.jitter + results.MS}</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{results.config.results.caller.summary?.dataRate}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Data Rate</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{results.config.results.callee.summary?.dataRate}</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{results.config.results.caller.summary?.codec}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Codec</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>{results.config.results.callee.summary?.codec}</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{results.config.results.caller.summary?.dialDelay}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Dial Delay</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>--</td>
                </tr>

                <tr>
                    <td className={classes.callerMetrics}>{results.config.results.caller.summary?.ringDelay}</td>
                    <td className={classes.metricLabel}>
                        <Trans>Ring Delay</Trans>
                    </td>
                    <td className={classes.calleeMetrics}>--</td>
                </tr>
            </tbody>
        </table>
    );
}
